import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BankAccountFormModel } from './form-group/bank-account-form.model';
import { RadioButton } from 'primeng/radiobutton';
import { FormForeignBankAccountComponent } from '../form-foreign-bank-account/form-foreign-bank-account.component';
import { FormDomesticBankAccountComponent } from '../form-domestic-bank-account/form-domestic-bank-account.component';
import { RadioButtonList } from '../../../models/custom-types';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Checkbox } from 'primeng/checkbox';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-form-bank-account',
  imports: [
    ReactiveFormsModule,
    RadioButton,
    FormForeignBankAccountComponent,
    FormDomesticBankAccountComponent,
    Checkbox,
    Tooltip,
  ],
  templateUrl: './form-bank-account.component.html',
  styleUrl: './form-bank-account.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormBankAccountComponent implements OnInit {
  public formGroup = input.required<FormGroup<BankAccountFormModel>>();
  protected readonly isForeignRadioElements: RadioButtonList[] = [
    { label: 'w Polsce', key: false },
    { label: 'w państwie UE/EFTA albo Wielkiej Brytanii', key: true },
  ];
  readonly #destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.#subscribeToIsForeignControl();
  }

  #subscribeToIsForeignControl(): void {
    this.formGroup()
      .controls.isForeign.valueChanges.pipe(
        tap(() => {
          if (this.formGroup().controls.isBankAccount.value) {
            this.#setAvailabilityOfOwnerDetailsControl();
            this.#resetAddresses();
          }
        }),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe();
  }

  #setAvailabilityOfOwnerDetailsControl(): void {
    if (this.formGroup().controls.isForeign.value) {
      this.formGroup().controls.foreignAccount.enable();
      this.formGroup().controls.domesticAccount.disable();
    } else {
      this.formGroup().controls.domesticAccount.enable();
      this.formGroup().controls.foreignAccount.disable();
    }
  }

  #resetAddresses(): void {
    this.formGroup().controls.domesticAccount.reset();
    this.formGroup().controls.foreignAccount.reset();
  }
}
